var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_15 clear" }, [
    _c(
      "div",
      {
        staticClass: "img_box",
        class: { cursor: _vm.data.url && _vm.data.radio !== 2 },
        on: {
          click: function($event) {
            return _vm.toPage(1)
          }
        }
      },
      [
        _c("img", { ref: "img", attrs: { src: _vm.data.src } }),
        _vm._v(" "),
        _vm.data.url
          ? _c(
              "div",
              {
                staticClass: "btn cursor",
                style: _vm.data.style,
                on: {
                  click: function($event) {
                    return _vm.toPage(2)
                  }
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("flowActive14")) + "\n      "
                )
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c34c6f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c34c6f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/details/public/id_15.vue
// module id = null
// module chunks = 